(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-gutschein-pro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const voucherApps = () => Array.from(document.querySelectorAll('.mc-gutschein-pro__app'));

    const applyVoucherBranding = () => {
      voucherApps().forEach((app) => {
        app.querySelectorAll('button, [role="button"]').forEach((element) => {
          const label = (element.textContent || '').replace(/\s+/g, ' ').trim();
          if (label.includes('Individueller Betrag') || label.includes('Mindestbetrag 10')) {
            element.style.setProperty('color', '#006699', 'important');
            element.style.setProperty('border-color', '#006699', 'important');
            element.style.setProperty('opacity', '1', 'important');
          }
        });
      });
    };

    const normalizeImageUrl = (value) => {
      if (typeof value !== 'string' || !value.trim()) return '';
      const url = value.trim();
      if (url.startsWith('data:') || url.startsWith('blob:')) return '';
      if (url.startsWith('//')) return window.location.protocol + url;
      if (url.startsWith('/')) return new URL(url, window.location.origin).href;
      try {
        const parsed = new URL(url, window.location.origin);
        if (!/^https?:$/.test(parsed.protocol)) return '';
        return parsed.href;
      } catch {
        return '';
      }
    };

    const usableImage = (image) => {
      if (!(image instanceof HTMLImageElement)) return '';
      const src = normalizeImageUrl(image.currentSrc || image.src || image.dataset.src || image.dataset.original || '');
      if (!src) return '';
      const marker = ((image.alt || '') + ' ' + (image.className || '') + ' ' + src).toLowerCase();
      if (/logo|payment|paypal|visa|mastercard|klarna|icon|spinner/.test(marker)) return '';
      const width = image.naturalWidth || Number(image.getAttribute('width')) || image.clientWidth || 0;
      const height = image.naturalHeight || Number(image.getAttribute('height')) || image.clientHeight || 0;
      if (width && height && (width < 120 || height < 70)) return '';
      return src;
    };

    const selectedImageFromForm = (form) => {
      const urlInput = Array.from(form.querySelectorAll('input[type="hidden"], input[type="url"]')).find((input) => {
        const marker = ((input.name || '') + ' ' + (input.id || '')).toLowerCase();
        return /image|bild|motiv|design|preview|upload/.test(marker) && normalizeImageUrl(input.value);
      });
      if (urlInput) return normalizeImageUrl(urlInput.value);

      const selected = form.querySelector(
        'input[type="radio"]:checked, input[type="checkbox"]:checked, [aria-selected="true"], [aria-pressed="true"], [data-selected="true"], .is-selected'
      );

      if (selected) {
        const selectedScope = selected.closest('label, button, [role="option"], li, article, div') || selected;
        const image = selectedScope.matches('img') ? selectedScope : selectedScope.querySelector('img');
        const src = usableImage(image);
        if (src) return src;
      }

      const previewSelectors = [
        '[data-preview] img',
        '[class*="preview"] img',
        '[class*="design"] img',
        '[class*="motif"] img',
        '[class*="motiv"] img',
        '[class*="gift-card"] img',
        '[class*="giftcard"] img'
      ];

      for (const selector of previewSelectors) {
        for (const image of form.querySelectorAll(selector)) {
          const src = usableImage(image);
          if (src) return src;
        }
      }

      return '';
    };

    const writeVoucherImageProperty = (form) => {
      if (!(form instanceof HTMLFormElement)) return;
      const imageUrl = selectedImageFromForm(form);
      let field = form.querySelector('input[name="properties[_mc_gutschein_bild]"]');

      if (!imageUrl) {
        if (field) field.remove();
        return;
      }

      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'properties[_mc_gutschein_bild]';
        form.appendChild(field);
      }

      field.value = imageUrl;
    };

    const syncVoucherForms = () => {
      voucherApps().forEach((app) => {
        app.querySelectorAll('form').forEach(writeVoucherImageProperty);
      });
    };

    const refreshVoucherUI = () => {
      applyVoucherBranding();
      syncVoucherForms();
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const app = event.target.closest('.mc-gutschein-pro__app');
      if (!app) return;
      window.setTimeout(() => app.querySelectorAll('form').forEach(writeVoucherImageProperty), 0);
    }, true);

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof Element)) return;
      const app = event.target.closest('.mc-gutschein-pro__app');
      if (!app) return;
      window.setTimeout(() => app.querySelectorAll('form').forEach(writeVoucherImageProperty), 0);
    }, true);

    document.addEventListener('submit', (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      if (!event.target.closest('.mc-gutschein-pro__app')) return;
      writeVoucherImageProperty(event.target);
    }, true);

    refreshVoucherUI();

    const observer = new MutationObserver(refreshVoucherUI);
    voucherApps().forEach((app) => {
      observer.observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-selected', 'aria-pressed', 'data-selected', 'src'] });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-header-v2"]) return;
  try {
    
  (() => {
    const headers = document.querySelectorAll('[data-mc2-header]');
    headers.forEach((header) => {
      const menuButton = header.querySelector('[data-mc2-menu-toggle]');
      const menu = header.querySelector('[data-mc2-mobile-menu]');
      const searchButtons = header.querySelectorAll('[data-mc2-search-toggle]');
      const search = header.querySelector('[data-mc2-search]');
      const searchInput = header.querySelector('[data-mc2-search-input]');
      const cartCount = header.querySelector('[data-mc2-cart-count]');
      header.querySelectorAll('.mc2-voucher-country-form').forEach((form) => {
        form.addEventListener('submit', (event) => {
          if (!window.confirm('Gutscheine gibt es derzeit nur im deutschen Shop. Möchtest du das Shopland ausdrücklich auf Deutschland umstellen und die Gutscheinseite öffnen?')) {
            event.preventDefault();
          }
        });
      });
      const closeMenu = () => { if (!menuButton || !menu) return; menu.hidden = true; menuButton.setAttribute('aria-expanded', 'false'); };
      const closeSearch = () => { if (!search) return; search.hidden = true; searchButtons.forEach((button) => button.setAttribute('aria-expanded', 'false')); };
      if (menuButton && menu) {
        menuButton.addEventListener('click', () => {
          const opening = menu.hidden;
          closeSearch();
          menu.hidden = !opening;
          menuButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
        });
      }
      searchButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!search) return;
          const opening = search.hidden;
          closeMenu();
          search.hidden = !opening;
          button.setAttribute('aria-expanded', opening ? 'true' : 'false');
          if (opening && searchInput) window.setTimeout(() => searchInput.focus(), 20);
        });
      });
      document.addEventListener('keydown', (event) => { if (event.key !== 'Escape') return; closeMenu(); closeSearch(); });
      window.addEventListener('resize', () => { if (window.innerWidth >= 990) closeMenu(); });
      const refreshCartCount = async (event) => {
        if (!cartCount) return;
        if (Number.isInteger(event?.detail?.item_count)) {
          cartCount.textContent = event.detail.item_count;
          cartCount.classList.toggle('is-empty', event.detail.item_count === 0);
          return;
        }
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          cartCount.textContent = cart.item_count;
          cartCount.classList.toggle('is-empty', cart.item_count === 0);
        } catch (error) {}
      };
      document.addEventListener('cart:updated', refreshCartCount);
      document.addEventListener('cart:build', refreshCartCount);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-newsletter-popup"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-mc-newsletter-popup]').forEach((root) => {
    const dialog = root.querySelector('[data-mc-newsletter-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const sectionId = root.dataset.sectionId || 'default';
    const storageKey = 'mc-newsletter-' + sectionId;
    const delaySeconds = Number(root.dataset.delaySeconds || 20);
    const delayDays = Number(root.dataset.delayDays || 7);
    const designMode = root.dataset.designMode === 'true';
    const success = Boolean(root.querySelector('[data-mc-newsletter-success]'));
    const error = Boolean(root.querySelector('[data-mc-newsletter-error]'));

    const remember = (days) => {
      const expiry = Date.now() + (days * 86400000);
      try {
        localStorage.setItem(storageKey, String(expiry));
      } catch (storageError) {}
    };

    const isRemembered = () => {
      try {
        const expiry = Number(localStorage.getItem(storageKey) || 0);
        if (!expiry) return false;
        if (Date.now() >= expiry) {
          localStorage.removeItem(storageKey);
          return false;
        }
        return true;
      } catch (storageError) {
        return false;
      }
    };

    const open = () => {
      if (!dialog.open) dialog.showModal();
    };

    const close = () => {
      if (dialog.open) dialog.close();
    };

    root.querySelectorAll('[data-mc-newsletter-close]').forEach((button) => {
      button.addEventListener('click', () => {
        remember(success ? 365 : delayDays);
        close();
      });
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        remember(success ? 365 : delayDays);
        close();
      }
    });

    dialog.addEventListener('cancel', () => {
      remember(success ? 365 : delayDays);
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail?.sectionId === sectionId) open();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail?.sectionId === sectionId) close();
    });

    if (window.location.pathname === '/challenge' || window.location.pathname === '/password') return;

    if (success) {
      remember(365);
      open();
      return;
    }

    if (error || designMode) {
      open();
      return;
    }

    if (!isRemembered()) {
      window.setTimeout(open, Math.max(5, delaySeconds) * 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-recently-viewed"]) return;
  try {
    
  class McRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const root = this;
      const grid = root.querySelector('[data-mc-recently-viewed-grid]');
      const currentData = root.querySelector('[data-mc-recently-viewed-current]');

      if (!grid || !currentData) return;

      const storageKey = 'mc_recently_viewed_products_v1';
      const limit = Math.min(8, Math.max(1, Number(root.dataset.limit) || 8));
      const currentProductId = root.dataset.currentProductId || '';
      const maxStored = Math.min(9, limit + 1);
      const maxAge = 30 * 24 * 60 * 60 * 1000;
      const now = Date.now();
      const locale = document.documentElement.lang || 'de-DE';
      const hideDutchVouchers = root.dataset.storefrontLocale === 'nl';
      const isVoucherUrl = (url) => /\/products\/(?:gutschein(?:-versand-per-post)?|gutscheine-membraclean-shop-de|membraclean-digitale-cadeaubonnen|membraclean-cadeaubon-per-post)(?:[/?#]|$)/i.test(String(url || ''));

      const labels = {
        price: root.dataset.priceLabel || '',
        inStock: root.dataset.inStockLabel || '',
        outOfStock: root.dataset.outOfStockLabel || '',
        savings: root.dataset.savingsLabel || '',
        noImage: root.dataset.noImageLabel || ''
      };

      const readStored = () => {
        try {
          const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      };

      const writeStored = (items) => {
        try {
          localStorage.setItem(storageKey, JSON.stringify(items));
        } catch (error) {
          return;
        }
      };

      const isValidItem = (item) => {
        if (!item || typeof item !== 'object') return false;
        if (!item.id || !item.url || !item.title) return false;
        const viewedAt = Number(item.viewedAt) || 0;
        return viewedAt === 0 || now - viewedAt <= maxAge;
      };

      const safeProductUrl = (value) => {
        try {
          const url = new URL(value, window.location.origin);
          if (url.origin !== window.location.origin) return null;
          if (!url.pathname.includes('/products/')) return null;
          return `${url.pathname}${url.search}${url.hash}`;
        } catch (error) {
          return null;
        }
      };

      const safeImageUrl = (value) => {
        if (!value) return null;
        try {
          const url = new URL(value, window.location.href);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
          return url.href;
        } catch (error) {
          return null;
        }
      };

      const formatMoney = (cents, currency) => {
        const amount = (Number(cents) || 0) / 100;
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency || 'EUR'
          }).format(amount);
        } catch (error) {
          return `${amount.toFixed(2)} ${currency || 'EUR'}`;
        }
      };

      const addText = (element, value) => {
        element.textContent = value == null ? '' : String(value);
        return element;
      };

      const createCard = (item) => {
        const productUrl = safeProductUrl(item.url);
        if (!productUrl) return null;

        const card = document.createElement('div');
        card.className = 'mc-card';

        const inner = document.createElement('div');
        inner.className = 'mc-card-inner';
        card.appendChild(inner);

        const imageLink = document.createElement('a');
        imageLink.className = 'mc-imgwrap';
        imageLink.href = productUrl;
        imageLink.setAttribute('aria-label', item.title);
        inner.appendChild(imageLink);

        const imageUrl = safeImageUrl(item.image);
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = item.imageAlt || item.title;
          image.loading = 'lazy';
          image.decoding = 'async';
          if (Number(item.imageWidth) > 0) image.width = Number(item.imageWidth);
          if (Number(item.imageHeight) > 0) image.height = Number(item.imageHeight);
          imageLink.appendChild(image);
        } else {
          const noImage = document.createElement('span');
          noImage.className = 'mc-recently-viewed__no-image';
          addText(noImage, labels.noImage);
          imageLink.appendChild(noImage);
        }

        const price = Number(item.price) || 0;
        const compareAtPrice = Number(item.compareAtPrice) || 0;
        const currency = item.currency || 'EUR';

        if (compareAtPrice > price) {
          const badge = document.createElement('div');
          badge.className = 'mc-badge';
          addText(badge, `${labels.savings} ${formatMoney(compareAtPrice - price, currency)}`);
          imageLink.appendChild(badge);
        }

        const body = document.createElement('div');
        body.className = 'mc-body';
        inner.appendChild(body);

        const title = document.createElement('h3');
        title.className = 'mc-title';
        const titleLink = document.createElement('a');
        titleLink.href = productUrl;
        addText(titleLink, item.title);
        title.appendChild(titleLink);
        body.appendChild(title);

        const priceWrapper = document.createElement('div');
        priceWrapper.className = 'mc-price-wrapper';
        body.appendChild(priceWrapper);

        const priceArea = document.createElement('div');
        priceArea.className = 'mc-price-area';
        priceWrapper.appendChild(priceArea);

        const priceLabel = document.createElement('div');
        priceLabel.className = 'mc-price-label';
        addText(priceLabel, labels.price);
        priceArea.appendChild(priceLabel);

        const priceRow = document.createElement('div');
        priceRow.className = 'mc-price-row';
        priceArea.appendChild(priceRow);

        const currentPrice = document.createElement('span');
        currentPrice.className = 'mc-now';
        addText(currentPrice, formatMoney(price, currency));
        priceRow.appendChild(currentPrice);

        if (compareAtPrice > price) {
          const comparePrice = document.createElement('span');
          comparePrice.className = 'mc-compare';
          addText(comparePrice, formatMoney(compareAtPrice, currency));
          priceRow.appendChild(comparePrice);
        }

        const unitPrice = Number(item.unitPrice) || 0;
        if (unitPrice > 0 && item.unitReferenceUnit) {
          const unit = document.createElement('div');
          unit.className = 'mc-unitprice';
          const referenceValue = Number(item.unitReferenceValue) || 1;
          const referencePrefix = referenceValue !== 1 ? String(referenceValue) : '';
          addText(unit, `${formatMoney(unitPrice, currency)} / ${referencePrefix}${item.unitReferenceUnit}`);
          priceArea.appendChild(unit);
        }

        const availability = document.createElement('div');
        availability.className = item.available
          ? 'mc-availability mc-availability--in'
          : 'mc-availability mc-availability--out';

        const availabilityDot = document.createElement('span');
        availabilityDot.className = 'mc-availability-dot';
        availability.appendChild(availabilityDot);

        const availabilityText = document.createElement('span');
        availabilityText.className = 'mc-availability-text';
        addText(availabilityText, item.available ? labels.inStock : labels.outOfStock);
        availability.appendChild(availabilityText);
        priceWrapper.appendChild(availability);

        return card;
      };

      let items = readStored().filter(isValidItem);
      let current = null;

      try {
        current = JSON.parse(currentData.textContent || 'null');
      } catch (error) {
        current = null;
      }

      if (current && current.id && current.url && current.title) {
        current.viewedAt = now;
        items = [
          current,
          ...items.filter((item) => String(item.id) !== String(current.id))
        ].slice(0, maxStored);
        writeStored(items);
      } else {
        writeStored(items.slice(0, maxStored));
      }

      const visibleItems = items
        .filter((item) => !currentProductId || String(item.id) !== String(currentProductId))
        .filter((item) => !hideDutchVouchers || !isVoucherUrl(item.url))
        .slice(0, limit);

      visibleItems.forEach((item) => {
        const card = createCard(item);
        if (card) grid.appendChild(card);
      });

      if (grid.children.length > 0) root.hidden = false;
    }
  }

  if (!customElements.get('mc-recently-viewed')) {
    customElements.define('mc-recently-viewed', McRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-slider"] && !Shopify.designMode) return;
  try {
    
  class McSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return
      this.initialized = true
      this.viewport = this.querySelector('[data-slider-viewport]')
      this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'))
      this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'))
      this.prevButton = this.querySelector('[data-slider-prev]')
      this.nextButton = this.querySelector('[data-slider-next]')
      this.pauseButton = this.querySelector('[data-slider-pause]')
      this.pauseIcon = this.querySelector('[data-slider-pause-icon]')
      this.index = 0
      this.userPaused = false
      this.interactionPaused = false
      this.scrollFrame = null
      this.timer = null
      this.abortController = new AbortController()
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      if (!this.viewport || this.slides.length === 0) return

      const signal = this.abortController.signal
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true, signal })
      this.viewport.addEventListener('keydown', this.handleKeydown, { signal })
      this.viewport.addEventListener('pointerdown', this.handlePointerDown, { signal })
      this.viewport.addEventListener('pointerup', this.handlePointerUp, { signal })
      this.viewport.addEventListener('pointercancel', this.handlePointerUp, { signal })
      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1, true), { signal })
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1, true), { signal })
      this.pauseButton?.addEventListener('click', this.togglePause, { signal })
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.sliderDot), true), { signal })
      })
      this.addEventListener('mouseenter', this.pauseForInteraction, { signal })
      this.addEventListener('mouseleave', this.resumeAfterInteraction, { signal })
      this.addEventListener('focusin', this.pauseForInteraction, { signal })
      this.addEventListener('focusout', this.handleFocusOut, { signal })
      document.addEventListener('visibilitychange', this.handleVisibilityChange, { signal })
      document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal })

      this.updateState(0)
      this.scheduleAutoplay()
    }

    disconnectedCallback() {
      this.abortController?.abort()
      this.clearTimer()
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame)
    }

    handleScroll = () => {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame)
      this.scrollFrame = requestAnimationFrame(() => {
        let nearestIndex = 0
        let nearestDistance = Number.POSITIVE_INFINITY
        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - this.viewport.scrollLeft)
          if (distance < nearestDistance) {
            nearestDistance = distance
            nearestIndex = index
          }
        })
        if (nearestIndex !== this.index) this.updateState(nearestIndex)
      })
    }

    handleKeydown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault()
        this.goTo(this.index - 1, true)
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault()
        this.goTo(this.index + 1, true)
      }
      if (event.key === 'Home') {
        event.preventDefault()
        this.goTo(0, true)
      }
      if (event.key === 'End') {
        event.preventDefault()
        this.goTo(this.slides.length - 1, true)
      }
    }

    handlePointerDown = () => {
      this.interactionPaused = true
      this.clearTimer()
    }

    handlePointerUp = () => {
      this.interactionPaused = false
      this.scheduleAutoplay()
    }

    handleFocusOut = (event) => {
      if (!event.relatedTarget || !this.contains(event.relatedTarget)) this.resumeAfterInteraction()
    }

    handleVisibilityChange = () => {
      if (document.hidden) this.clearTimer()
      else this.scheduleAutoplay()
    }

    handleBlockSelect = (event) => {
      const slide = event.target?.closest?.('[data-slider-slide]')
      if (!slide || !this.contains(slide)) return
      const selectedIndex = this.slides.indexOf(slide)
      if (selectedIndex >= 0) this.goTo(selectedIndex, true)
    }

    pauseForInteraction = () => {
      this.interactionPaused = true
      this.clearTimer()
    }

    resumeAfterInteraction = () => {
      this.interactionPaused = false
      this.scheduleAutoplay()
    }

    togglePause = () => {
      this.userPaused = !this.userPaused
      if (this.pauseIcon) this.pauseIcon.textContent = this.userPaused ? '▶' : 'Ⅱ'
      if (this.pauseButton) {
        const label = this.userPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel
        if (label) this.pauseButton.setAttribute('aria-label', label)
      }
      if (this.userPaused) this.clearTimer()
      else this.scheduleAutoplay()
    }

    goTo(index, userInitiated) {
      const loop = this.dataset.loop === 'true'
      let target = index
      if (loop) target = (target + this.slides.length) % this.slides.length
      else target = Math.max(0, Math.min(target, this.slides.length - 1))

      const behavior = this.reducedMotion ? 'auto' : 'smooth'
      this.viewport.scrollTo({ left: this.slides[target].offsetLeft, behavior })
      this.updateState(target)
      if (userInitiated) this.scheduleAutoplay()
    }

    updateState(index) {
      this.index = index
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index
        dot.classList.toggle('is-active', active)
        if (active) dot.setAttribute('aria-current', 'true')
        else dot.removeAttribute('aria-current')
      })

      const loop = this.dataset.loop === 'true'
      if (this.prevButton) this.prevButton.disabled = !loop && index === 0
      if (this.nextButton) this.nextButton.disabled = !loop && index === this.slides.length - 1
    }

    scheduleAutoplay() {
      this.clearTimer()
      const autoplay = this.dataset.autoplay === 'true'
      if (!autoplay || this.slides.length < 2 || this.reducedMotion || this.userPaused || this.interactionPaused || document.hidden) return

      const interval = Math.max(3000, Number(this.dataset.interval) || 7000)
      this.timer = window.setTimeout(() => {
        const loop = this.dataset.loop === 'true'
        if (!loop && this.index >= this.slides.length - 1) return
        this.goTo(this.index + 1, false)
        this.scheduleAutoplay()
      }, interval)
    }

    clearTimer() {
      if (!this.timer) return
      window.clearTimeout(this.timer)
      this.timer = null
    }
  }

  if (!customElements.get('mc-slider')) customElements.define('mc-slider', McSlider)

  } catch(e) { console.error(e); }
})();
})();
